import React from 'react';
import PropTypes from 'prop-types';
import { eventCreateSteps } from '../../../utils/constants';
import { EventTypes } from '../../../utils/events';
import { tierShape } from '../../../propTypes';

const StepFooter = (props) => {
    const {
        currentStep,
        eventType,
        handleToStepClick,
        showPaymentSetup,
        submitting,
        tiersHasErrors,
        tiers,
        hasEventNameAndLocation,
    } = props;
    const tierNameError = tiers?.tiers?.filter(tier => tier?.shortName?.trim() === '').length !== 0 && currentStep === eventCreateSteps.STEPS_4;
    const isHealthStep = currentStep === eventCreateSteps.STEPS_5;
    const disableNextBtn = submitting || currentStep === eventCreateSteps.STEPS_6 || tiersHasErrors || tierNameError;
    const showNext = !isHealthStep || (isHealthStep && showPaymentSetup);
    return (
        <>
            {!!eventType && hasEventNameAndLocation && (
                <div className="row mb56 mt32">
                    <div className="col-12 col-md-4 mb16">
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                handleToStepClick('prev');
                            }}
                            type="submit"
                            className="btn btn-default btn-xl text-uppercase btn-block"
                            disabled={currentStep === 1}
                            data-testid="event-edit-wizard.step-footer.back-btn"
                        >
                            Back
                        </button>
                    </div>
                    {hasEventNameAndLocation && (eventType === EventTypes.DUAL_MATCH || eventType === EventTypes.TEAM_MATCH) && (
                        <div className="col-12 col-md-4 offset-md-4">
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleToStepClick();
                                }}
                                type="submit"
                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                disabled={submitting}
                                data-testid="event-edit-wizard.step-footer.create-btn"
                            >
                                Create
                            </button>
                        </div>
                    )}
                    {hasEventNameAndLocation && eventType !== EventTypes.DUAL_MATCH && eventType !== EventTypes.TEAM_MATCH && showNext && (
                        <div className="col-12 col-md-4 offset-md-4">
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleToStepClick('next');
                                }}
                                type="submit"
                                className="btn btn-primary btn-xl text-uppercase btn-block"
                                disabled={disableNextBtn}
                                data-testid="event-edit-wizard.step-footer.next-btn"
                            >
                                Next
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

export default StepFooter;
StepFooter.propTypes = {
    currentStep: PropTypes.number.isRequired,
    eventType: PropTypes.number.isRequired,
    handleToStepClick: PropTypes.func.isRequired,
    showPaymentSetup: PropTypes.bool,
    submitting: PropTypes.bool.isRequired,
    tiersHasErrors: PropTypes.bool.isRequired,
    tiers: PropTypes.shape({
        tiers: PropTypes.arrayOf(tierShape),
    }).isRequired,
    hasEventNameAndLocation: PropTypes.bool,

};
StepFooter.defaultProps = {
    showPaymentSetup: false,
    hasEventNameAndLocation: false,
};
